import {Component, Input, OnInit} from '@angular/core';
import {useDefault} from '../../common/common';
import {RateRule} from '../../api/model/reservation/rate/rate-rule.model';
@Component({
  selector: 'rate-rule',
  templateUrl: './rate-rule.component.html',
  styleUrls: ['./rate-rule.component.scss']
})
export class RateRuleComponent implements OnInit {
  @Input() messages;
  @Input() rateRule: RateRule;
  ruleText: string;

  ngOnInit() {
    this.ruleText = useDefault(this.rateRule.description, this.messages['reservation.rule.' + this.rateRule.type]);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/rate-rule/rate-rule.component.ts